// Central brand/copy config for Lynx Life.
// To create a new skin, change the values here (and src/css/theme.css),
// then swap the referenced files in public/. No component logic changes.

const siteConfig = {
  brandName: "Lynx Life",
  brandNameLong: "Lynx LifeStyle Club",
  tagline: "Games, quizzes & good vibes — all in one place",

  footerCopyright: `Copyright © Lynx Lifestyle Club ${new Date().getFullYear()}`,

  supportEmail: "Info@lynxlife.club",
  supportPhone: "0109003333",

  images: {
    logo: "/logo.png",
    mascot: "/mascot.png",
    heroBackground: "/lynx2.jpg",
    winBackground: "/lynx-trophy.jpg",
    quizBackground: "/QUIZ.jpeg",
    wallpaperBackground: "/wallpaper-gradient.jpg",
  },
};

export default siteConfig;
